export const CHECK_AUTH = 'checkAuth'
export const FETCH_PROFILE = 'fetchProfile'
export const LOGIN = 'login'
export const LOGOUT = 'logout'
export const REGISTER = 'register'
export const UPDATE_USER = 'updateUser'

export const FETCH_USERS = 'fetchUsers'
